import { motion } from "framer-motion";
import { Sparkle } from "lucide-react";
import { BOOKING_URL } from "@/components/Nav";

export default function FloatingCTA() {
  return (
    <motion.a
      href={BOOKING_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-book-now-button"
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 1.6, duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2.5 rounded-full bg-[#11261A] text-[#F9FAF8] pl-5 pr-7 py-3.5 shadow-[0_10px_30px_rgba(17,38,26,0.35)] transition-all duration-300 hover:bg-black hover:shadow-[0_16px_40px_rgba(0,0,0,0.4)] hover:-translate-y-1"
    >
      <Sparkle size={15} className="text-[#8EA696]" />
      <span className="text-[12px] uppercase tracking-[0.22em] font-medium">Book Now</span>
    </motion.a>
  );
}
